import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-low-balance-dialog',
  templateUrl: './low-balance-dialog.component.html',
  styleUrls: ['./low-balance-dialog.component.css']
})
export class LowBalanceDialogComponent implements OnInit {

  alertType: string;
  message: string;
  title: string;

  constructor(public dialogRef: MatDialogRef<LowBalanceDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.alertType = this.data.alertType;
    this.message = this.data.message;
    this.title = this.data.title;
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/low-balance-dialog/low-balance-dialog.component.ts